<template>
  <d-container
    fluid
    class="main-content-container px-4">
    <!-- Page Header -->
    <d-row
      no-gutters
      class="page-header py-4">
      <d-col
        col
        sm="3"
        class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Dział Płatności</span>
        <h3 class="page-title">Historia płatności</h3>
      </d-col>
    </d-row>
    <d-row
      class="d-flex ml-0 mb-3 page-filters w-100">
      <validation-observer
        ref="payments-filters-form"
        tag="form"
        style="width: 100%;"
        class="d-flex">
        <d-input
          placeholder="Szukana fraza (podstawowe dane klienta, numer zamówienia, podstawowe dane placówki)"
          v-model="filters.search" />
        <filter-autocomplete
          v-model="filters.customer_id"
          style="width: 100%"
          class="ml-2"
          :endpoint-items="'/customers/items'"
          :data-id="filters.customer_id"
          :reduce="obj => obj.id"
          :endpoint-item="'/customers/item/'"
          :placeholder="'Wybierz klienta'"/>
        <d-button
          theme="info"
          outline
          class="text-nowrap ml-2"
          @click.prevent="validateFiltersForm">Szukaj</d-button>

        <d-button
          theme="danger"
          outline
          class="text-nowrap ml-2"
          @click.prevent="clearFilters">Resetuj filtry</d-button>
      </validation-observer>
    </d-row>
    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th
              scope="col"
              class="border-0 rwd-disabled">ID</th>
            <th
              scope="col"
              class="border-0">Data wpłaty</th>
            <th
              scope="col"
              class="border-0">Nr zamówienia/Placówka/Kwota</th>
            <th
              scope="col"
              class="border-0">Klient</th>
            <th
              scope="col"
              class="border-0"
              style="width: 200px;">Rodzaj</th>
            <th
              scope="col"
              class="border-0"
              style="width: 200px;">Kwota</th>
            <th
              scope="col"
              class="border-0">Akcje</th>
          </tr>
        </thead>
        <tbody v-if="loaded && payments">
          <tr
            v-for="(payment, index) of payments"
            :key="'user-' + index">
            <td class="align-middle rwd-disabled">
              {{ payment.id }}
            </td>
            <td class="align-middle">
              {{ payment.payment_date }}
            </td>
            <td class="align-middle">
              <ul class="mb-0 pl-3">
                <li
                  class="mb-1"
                  v-for="order in payment.orders"
                  :key="order.order_id">
                  <a
                    href="#"
                    @click.prevent="$router.push('/zamowienia/edycja/' + order.order_id)"
                    class="mr-1">{{ order.order_id }}</a>
                  <span class="text-info"><span
                    class="material-icons"
                  style="font-size: 12px;">store</span> {{ order.shop_name }}</span> - {{ Number(order.amount).toFixed(2) }} zł
                </li>
              </ul>
            </td>
            <td class="align-middle">
              <span class="text-success">{{ payment.customer_name }}</span>
            </td>
            <td class="align-middle">
              {{ getPaymentMethodName(payment.settlement_method) }}
            </td>
            <td class="align-middle">
              {{ Number(payment.amount).toFixed(2) }} zł
            </td>
            <td
              class="align-middle"
              style="width: 150px;">
              <d-button
                v-if="payment.can_delete"
                @click.prevent="removePayment(payment)"
                theme="danger">
                <i class="material-icons">delete</i>
              </d-button>
            </td>
          </tr>
          <tr v-if="payments.length === 0">
            <td
              colspan="7"
              class="text-center">
              Brak rozliczeń do wyświetlenia&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <div
        v-if="!loaded || !payments"
        class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>

      <d-alert
        v-if="load_error"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się. <a
          href="javascript:window.location.reload();"
        class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
      </d-alert>
    </d-card>

    <pagination
      :meta-data="paginationMetaData"
      :initial-page="currentPage"/>
  </d-container>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from '../../utils/FormUtils.js';
import HasFilters from '../../mixins/HasFilters.vue';
import HasPagination from '../../mixins/HasPagination.vue';
import ListUtils from '../../utils/ListUtils.js';
import Pagination from '../../components/common/Pagination.vue';
import FilterAutocomplete from '../../components/others/filterAutocomplete.vue';
import PaymentMethods from '@/data/payments-methods.js';

export default {
  name: 'payments',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    FilterAutocomplete,
    'pagination': Pagination
  },
  data () {
    return {
      payments: [],
      loaded: false,
      load_error: false,
      remove_in_progress: false,
      show_payment_module: false,
      downloading: false,
      key_payment_module: 0,
      submitting: {
        remove: false,
      },
      filters: {
        search: '',
        customer_id: ''
      }
    };
  },
  computed: {
    paymentMethods () {
      return PaymentMethods;
    },
  },
  mounted () {
    this.debouncedLoadFilteredData();
  },
  methods: {
    refresh () {
      this.loadFilteredData();
      this.key_payment_module += 1;
    },
    removePayment ({ id }) {
      this.remove_in_progress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/customers/payments/delete/',
        id,
        successTitle: 'Usunięto Wpłatę',
        successText: 'Wybrana wpłata została usunięta',
        confirmTitle: 'Czy na pewno chcesz usunąć wybraną wpłatę?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie wpłaty nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.remove_in_progress = false;
          this.loadFilteredData();
        },
        cancelAction: () => {
          this.remove_in_progress = false;
        }
      });
    },
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.$emit('view-filters-save');
      this.loadFilteredData();
    }, 250),
    loadFilteredData () {
      let where = {};

      if (this.filters.search !== '') {
        where.search = this.filters.search;
      }
      if (this.filters.customer_id !== '') {
        where.customer_id = this.filters.customer_id;
      }

      ListUtils.loadItemsData(this, {
        endpoint: '/customers/payments/items?page=' + this.currentPage,
        listField: 'payments',
        errorKey: 'load_error',
        pagination: true,
        params: {
          where
        }
      });
    },
    clearFilters () {
      this.loaded = false;
      this.load_error = false;
      this.filters = {
        number: '',
        month: '',
        year: '',
        settlement_method: '',
        customer_id: ''
      };

      this.loadFilteredData();
      this.$bus.$emit('view-filters-reset');
    },
    validateFiltersForm () {
      this.$bus.$emit('pagination-reset');
      FormUtils.validate(this.$refs['payments-filters-form'], this.debouncedLoadFilteredData);
    },
    getPaymentMethodName (methodID) {
      if (!methodID) {
        return '-';
      }

      let methodFound = this.paymentMethods.find(item => item.id === methodID);
      if (!methodFound || !methodFound.name) {
        return '-';
      }

      return methodFound.name;
    }
  }
};
</script>
<style lang="scss">
  .orders-list {
    max-width: 30%;
  }
  .my-collapse {
    position: absolute;
    width: 210px;
    z-index: 100;
    background-color: #fff;
    .rounded {
    }
  }
</style>

